import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFormField]',
})
export class FormFieldDirective {
  constructor(private elementRef: ElementRef<HTMLButtonElement>) {
    this.elementRef.nativeElement.classList.add('manteca-input');
  }
}
